import { Modal } from "react-bootstrap";
import React, { useState } from "react";

const CareerModal = ({ modalInfo, showModal, setModal }) => {
  const [show, setShow] = useState(false);
  const handleModal = () => {
    setShow(true);
  };

  return (
    <div className="">
      <div className="career-modal">
        <button className="main-btn" onClick={handleModal}>
          SEE DETAILS
        </button>

        <Modal
          show={showModal}
          centered
          onHide={() => setModal(false)}
          className="career-modal"
          dialogClassName="modal-90w modal-80h"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              <h3 className="news-details-titile">
                {" "}
                {modalInfo?.designation[0]?.text}
              </h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="news-details-body text-muted p-3">
              <p>{modalInfo?.description[0]?.text}</p>
              <p>{modalInfo?.job_description[0]?.text}</p>
              <p className="fw-bold">Responsibilities</p>
              <ul className="ps-4">
                {modalInfo?.job_resposibilities?.map((jobInfo) => (
                  <li key={jobInfo}>{jobInfo?.resposibility[0]?.text}</li>
                ))}
              </ul>
              <p className="fw-bold">Requirements</p>
              <ul className="ps-4">
                {modalInfo?.jobRequires?.map((jobInfo) => (
                  <li key={jobInfo}>{jobInfo?.requires[0]?.text}</li>
                ))}
              </ul>
              <p className="fw-bold">
                {modalInfo?.working_condition.length > 0
                  ? "Working Conditions"
                  : ""}
              </p>
              <ul className="ps-4">
                {modalInfo?.working_condition?.map(
                  (jobInfo) =>
                    jobInfo?.condition && (
                      <li key={jobInfo}>{jobInfo?.condition}</li>
                    )
                )}{" "}
              </ul>
              <a
                target="_blank"
                href={modalInfo?.link[0]?.text}
                className="text-decoration-none"
              >
                <button className="primary-btn  ">APPLY NOW</button>
              </a>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default CareerModal;
